// src/redux/posts/publicUserPosts/publicUserPostsActions.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import PublicUserPostsAPI from "./publicUserPostsAPI";

export const fetchPublicUserPosts = createAsyncThunk(
  "publicUserPosts/fetch",
  async ({ userId, skip = 0, limit = 20, sort_by = "latest", period = "all" }, { rejectWithValue }) => {
    try {
      return await PublicUserPostsAPI.fetch(userId, skip, limit, sort_by, period);
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || err.message);
    }
  }
);
